import {useState} from 'react';
import {Button, Spin, Upload} from 'antd';
import {PictureOutlined, UploadOutlined} from '@ant-design/icons';
import {toast} from 'react-toastify';
import {ICON_FOLDER} from './constants';
import {uploadIconToBucket} from './utils';
import styles from './FlowBuilder.module.scss';

/**
 * Direct child of <Form.Item name="iconUrl"> — antd injects value/onChange.
 * Uploads to the helpdesk S3 bucket and writes the resulting URL back.
 */
export const IconEditor = ({value, onChange, folder = ICON_FOLDER}) => {
  const [uploading, setUploading] = useState(false);

  const handleBeforeUpload = async file => {
    if (!file.type?.startsWith('image/')) {
      toast.error('Please upload an image file (PNG, JPG, or SVG).');
      return Upload.LIST_IGNORE;
    }
    try {
      setUploading(true);
      const fileLink = await uploadIconToBucket(file, folder);
      if (fileLink) {
        onChange(fileLink);
        toast.success('Icon uploaded');
      } else {
        toast.error('Icon upload failed');
      }
    } catch (e) {
      toast.error(e?.message || 'Icon upload failed');
    } finally {
      setUploading(false);
    }
    return false; // prevent antd's default upload
  };

  return (
    <div className={styles.iconEditor}>
      <div className={styles.iconPreview}>
        {value ? (
          <img src={value} alt="icon" />
        ) : uploading ? (
          <Spin size="small" />
        ) : (
          <PictureOutlined style={{color: '#94a3b8', fontSize: 22}} />
        )}
      </div>
      <div style={{display: 'flex', flexDirection: 'column', gap: 6, flex: 1}}>
        <Upload
          beforeUpload={handleBeforeUpload}
          maxCount={1}
          accept="image/*"
          disabled={uploading}
          showUploadList={false}>
          <Button icon={<UploadOutlined />} loading={uploading}>
            {value ? 'Replace icon' : 'Upload icon'}
          </Button>
        </Upload>
        {value ? (
          <Button
            type="link"
            danger
            size="small"
            style={{padding: 0, alignSelf: 'flex-start'}}
            onClick={() => onChange('')}>
            Remove
          </Button>
        ) : (
          <span style={{fontSize: 11, color: '#94a3b8'}}>
            PNG / JPG / SVG · recommended 64×64
          </span>
        )}
      </div>
    </div>
  );
};
